import React from "react";
import "./App.css";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import EVChargerBanner from "./components/EVChargerBanner";
import ServiceAreasSection from "./components/ServiceAreasSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <EVChargerBanner />
        <ServiceAreasSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
